import { Link } from "react-router-dom";
import SEO from "../components/SEO"; // Add this import
import "./legal.css";

const TermsOfService = () => {
  return (
    <>
      {/* Add SEO component with noindex settings */}
      <SEO
        title="Terms of Service - Anjali Daswani Music"
        description="Terms of Service for Anjali Daswani's official music website and content. Understand the terms governing your use of this website."
        url="https://anjalidmusic.com/terms"
        keywords="terms of service, Anjali Daswani, website terms, legal agreement"
        // robots="noindex, follow" // Don't index legal pages but allow following links
      />

      <div className="legal-page">
        {/* Hero Section */}
        <section className="legal-hero-section">
          <div className="container">
            <div className="legal-hero-content">
              <h1 className="legal-title">Terms of Service</h1>
              <p className="legal-subtitle">
                Last updated:{" "}
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="legal-content-section">
          <div className="container">
            <div className="legal-content">
              <div className="legal-intro">
                <p>
                  These Terms of Service ("Terms") govern your use of the Anjali
                  Daswani website and services. By accessing or using this
                  website, you agree to be bound by these Terms.
                </p>
              </div>

              <div className="legal-section">
                <h2>Acceptance of Terms</h2>
                <p>
                  By accessing and using this website, you accept and agree to
                  be bound by the terms and provision of this agreement. If you
                  do not agree to abide by the above, please do not use this
                  service.
                </p>
              </div>

              <div className="legal-section">
                <h2>Use of the Website</h2>
                <p>
                  You may use this website for lawful purposes only. You agree
                  not to use the website:
                </p>
                <ul>
                  <li>
                    In any way that violates any applicable federal, state,
                    local, or international law
                  </li>
                  <li>
                    To send spam, unsolicited messages, or promotional materials
                  </li>
                  <li>
                    To attempt to gain unauthorized access to any systems or
                    data
                  </li>
                  <li>
                    To interfere with or disrupt the website's functionality
                  </li>
                  <li>
                    To upload or transmit harmful, offensive, or inappropriate
                    content
                  </li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Intellectual Property Rights</h2>
                <p>
                  All content on this website, including but not limited to
                  music, lyrics, images, text, graphics, and design, is the
                  property of Anjali Daswani and is protected by copyright and
                  other intellectual property laws.
                </p>
                <p>
                  You may not reproduce, distribute, modify, or create
                  derivative works of any content without express written
                  permission.
                </p>
              </div>

              <div className="legal-section">
                <h2>Music and Content</h2>
                <p>
                  The music and content provided on this website are for
                  personal, non-commercial use only. Any commercial use,
                  reproduction, or distribution requires prior written consent.
                </p>
                <p>
                  Streaming and download links direct you to third-party
                  platforms (Spotify, Apple Music, etc.) which have their own
                  terms of service.
                </p>
              </div>

              <div className="legal-section">
                <h2>User-Generated Content</h2>
                <p>
                  When you submit content through contact forms or other means,
                  you grant Anjali Daswani a non-exclusive, royalty-free license
                  to use, reproduce, and respond to your submissions for the
                  purpose of providing services and communication.
                </p>
                <p>
                  You are responsible for ensuring that any content you submit
                  does not infringe on third-party rights or violate any laws.
                </p>
              </div>

              <div className="legal-section">
                <h2>Third-Party Links and Services</h2>
                <p>
                  This website contains links to third-party websites and
                  services. Anjali Daswani is not responsible for the content,
                  privacy policies, or practices of these third-party sites.
                </p>
                <p>
                  Your interactions with third-party services are governed by
                  their respective terms and privacy policies.
                </p>
              </div>

              <div className="legal-section">
                <h2>Disclaimers</h2>
                <p>
                  This website and its content are provided "as is" without any
                  representations or warranties. No warranties are made
                  regarding:
                </p>
                <ul>
                  <li>The accuracy, reliability, or completeness of content</li>
                  <li>Uninterrupted or error-free website operation</li>
                  <li>
                    The availability of external links or streaming services
                  </li>
                  <li>The security of data transmission</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Limitation of Liability</h2>
                <p>
                  To the fullest extent permitted by law, Anjali Daswani shall
                  not be liable for any indirect, incidental, special,
                  consequential, or punitive damages arising from your use of
                  this website or services.
                </p>
              </div>

              <div className="legal-section">
                <h2>Privacy</h2>
                <p>
                  Your privacy is important. Please review the{" "}
                  <Link to="/privacy" className="legal-link">
                    Privacy Policy
                  </Link>{" "}
                  to understand how information is collected, used, and
                  protected.
                </p>
              </div>

              <div className="legal-section">
                <h2>Changes to Terms</h2>
                <p>
                  Anjali Daswani reserves the right to modify these Terms at any
                  time. Changes will be effective immediately upon posting to
                  this website. Your continued use of the website constitutes
                  acceptance of the modified Terms.
                </p>
              </div>

              <div className="legal-section">
                <h2>Governing Law</h2>
                <p>
                  These Terms shall be governed by and construed in accordance
                  with the laws of the State of New York, without regard to its
                  conflict of law provisions.
                </p>
              </div>

              <div className="legal-section">
                <h2>Contact Information</h2>
                <p>
                  If you have any questions about these Terms of Service, please
                  contact Anjali Daswani through the{" "}
                  <Link to="/contact" className="legal-link">
                    contact form
                  </Link>
                  .
                </p>
              </div>

              <div className="legal-navigation">
                <Link to="/privacy" className="btn-secondary">
                  View Privacy Policy
                </Link>
                <Link to="/" className="btn-primary">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsOfService;
